"use strict";

import { getCssPrefix } from "@runtime/runner/legacy-features";

var PyDefUtils = require("PyDefUtils");

module.exports = function(pyModule) {

	pyModule["DesignXYPanel"] = Sk.misceval.buildClass(pyModule, function($gbl, $loc) {
        $loc["__init__"] = new Sk.builtin.func(PyDefUtils.withRawKwargs(function(kwargs, self) {
            Sk.misceval.call(pyModule["XYPanel"].prototype["__init__"], undefined, undefined, kwargs, self);

            self._anvil.element.css("position", "relative").append(`<div class='anvil-designer-hatching-left xypanel-hatching-${self._anvil.panelId}'></div><div class='hatching-right xypanel-hatching-${self._anvil.panelId}'></div>`)

            self._anvil.updateHatching = (width) => {
                var l = self._anvil.element.find(`.anvil-designer-hatching-left.xypanel-hatching-${self._anvil.panelId}`);
                var r = self._anvil.element.find(`.anvil-designer-hatching-right.xypanel-hatching-${self._anvil.panelId}`);
                var w = (width === undefined) ? (self._anvil.getPropJS("width")) : width;
                if (w === null) {
                    l.css("right", "100%");
                    r.css("left", "100%");
                    return;
                }
                switch(self._anvil.getPropJS("align")) {
                    case "left":
                        l.css("right", "100%");
                        r.css("left", "calc("+w+"px)")
                        break;
                    case "right":
                        l.css("right", "calc("+w+"px)");
                        r.css("left", "100%")
                        break;
                    case "center":
                        l.css("right", "calc(50% + "+w/2+"px)");
                        r.css("left", "calc(50% + "+w/2+"px)");
                        break;
                }
            };
            self._anvil.updateHatching();

            var SNAP_SPACING = 10; // This should be configurable by the theme

            var SNAP_DISTANCE = 5;

            // Try to make this independent of axis
            let trySnap = (currentSnap, thisPos, componentPos, componentSize, snapSpacing, componentOtherAxisMidpoint, tag, disfavour) => {
                let dist = Math.abs(componentPos - thisPos);
                let newSnap = componentPos, standoff = undefined;
                newSnap = componentPos;

                if (componentSize !== undefined) {
                    let followPos = componentPos + componentSize + snapSpacing;
                    let followDist = Math.abs(followPos - thisPos);
                    if (followDist < dist) {
                        dist = followDist;
                        newSnap = followPos;
                        standoff = componentOtherAxisMidpoint;
                    }
                }

                if (dist <= SNAP_DISTANCE && (currentSnap === undefined || dist < currentSnap.dist || currentSnap.disfavour && !disfavour && dist == currentSnap.dist)) {
                    return {pos: newSnap, standoff: standoff, spacing: snapSpacing, dist: dist, tag: tag, disfavour: disfavour};
                } else {
                    return currentSnap;
                }
            }

            self._anvil.whereWillItLand = function(x, y, width, height, mouseX, mouseY, pyMovingComponent) {
                var myOffset = self._anvil.element.offset();
                var myWidth = self._anvil.element.width();
                var myHeight = self._anvil.element.height();

                var holderOffset = self._anvil.element.find(`.${getCssPrefix()}holder.xypanel-${self._anvil.panelId}`).offset();
                var holderWidth = self._anvil.element.find(`.${getCssPrefix()}holder.xypanel-${self._anvil.panelId}`).width();
                var holderHeight = self._anvil.element.find(`.${getCssPrefix()}holder.xypanel-${self._anvil.panelId}`).height()

                var snapX, snapY;

                // Try snapping against the edges of the panel
                snapX = trySnap(snapX, x, holderOffset.left, 0, SNAP_SPACING, y+height/2);
                snapX = trySnap(snapX, x+width, holderOffset.left+holderWidth, 0, -SNAP_SPACING, y+height/2, -width);
                snapY = trySnap(snapY, y, myOffset.top, 0, SNAP_SPACING, x+width/2);
                snapY = trySnap(snapY, y+height, myOffset.top+myHeight, 0, -SNAP_SPACING, x+width/2, -height);

                for (let c of self._anvil.components) {
                    let elt = $(c.component.anvil$hooks.domElement);
                    let w = elt.outerWidth(), h = elt.outerHeight();
                    let offset = elt.offset();
                    // Disfavour self-matches (in the event of a tie, display a different guideline)
                    let disfavour = c.component === pyMovingComponent;
                    snapX = trySnap(snapX, x, offset.left, w, SNAP_SPACING, offset.top+h/2, null, disfavour);
                    snapX = trySnap(snapX, x+width, offset.left+w, -w, -SNAP_SPACING, offset.top+h/2, -width, disfavour);
                    snapY = trySnap(snapY, y, offset.top, h, SNAP_SPACING, offset.left+w/2, null, disfavour);
                    snapY = trySnap(snapY, y+height, offset.top+h, -h, -SNAP_SPACING, offset.left+w/2, -height, disfavour);
                }

                let guidelines = [];

                if (snapX !== undefined) {
                    guidelines.push({x1: snapX.pos, y1: myOffset.top, x2: snapX.pos, y2: myOffset.top+myHeight, lineWidth: 2});
                    x = snapX.pos + (snapX.tag || 0);
                    if (snapX.standoff !== undefined) {
                        guidelines.push({x1: snapX.pos-snapX.spacing, y1: snapX.standoff, x2: snapX.pos, y2: snapX.standoff, lineWidth: 2});
                    }
                }
                if (snapY !== undefined) {
                    guidelines.push({y1: snapY.pos, x1: myOffset.left, y2: snapY.pos, x2: myOffset.left+myWidth, lineWidth: 2});
                    y = snapY.pos + (snapY.tag || 0);
                    if (snapY.standoff !== undefined) {
                        guidelines.push({y1: snapY.pos-snapY.spacing, x1: snapY.standoff, y2: snapY.pos, x2: snapY.standoff, lineWidth: 2});
                    }
                }

                var holder = this.element.find(`.${getCssPrefix()}holder.xypanel-${self._anvil.panelId}`);

                return {childIdx: holder.children().length,
                        layoutProperties: {
                            x: x - holder.offset().left,
                            y: y - holder.offset().top,
                            width: width,
                        },
                        estimatedPosition: {x: x, y: y, width: width, height: height},
                        guidelines: guidelines
                    };
            }

            self._anvil.setLayoutProperties = function(pyChild, props) {
                var elt = $(pyChild.anvil$hooks.domElement);

                if (props.x) { elt.css("left", props.x); }
                if (props.y) { elt.css("top", props.y); }
                if (props.width) { elt.css("width", props.width); }

                var ps = {};
                ps[pyChild._anvil?.componentSpec.name] = { x: elt.position().left, y: elt.position().top, width: elt.width() };
                return ps;
            }

            self._anvil.getHandles = function(pyChild) {
                if (pyChild) {
                    // Get layout handles for pyChild
                    var e = $(pyChild.anvil$hooks.domElement);
                    var offset = e.offset();
                    var w = e.outerWidth();
                    var h = e.outerHeight();

                    return [{
                        x: offset.left + w,
                        y: offset.top + h/2 - 5,
                        width: 10,
                        height: 10,
                        cursor: "ew",
                        childName: pyChild._anvil?.componentSpec?.name,
                        owner: self._anvil?.componentSpec?.name,
                    }];



                } else {
                    // Get our own height and width handles
                    var element = self._anvil.element;
                    var holder = self._anvil.element.find(`.${getCssPrefix()}holder.xypanel-${self._anvil.panelId}`);
                    var offset = element.offset();
                    var holderOffset = holder.offset();
                    var w = element.outerWidth();
                    var h = element.outerHeight();
                    var hw = holder.outerWidth();
                    var hh = holder.outerHeight();

                    var align = self._anvil.getPropJS("align");

                    return [{
                        x: holderOffset.left + hw/2 - 5,
                        y: offset.top+h,
                        width: 10,
                        height: 10,
                        cursor: "ns",
                        owner: self._anvil?.componentSpec?.name,
                        prop: "height"
                    }, {
                        x: holderOffset.left + ((align=="right") ? -10 : hw),
                        y: holderOffset.top + hh/4 - 5,
                        width: 10,
                        height: 10,
                        cursor: "ew",
                        owner: self._anvil?.componentSpec?.name,
                        prop: "width",
                        factor: {"left":1,"right":-1,"center":2}[align] || 1,
                    }];
                }
            };

            self._anvil.handleGrab = function(handle, mouseX, mouseY) {
                if (handle.pyChild) {
                    // This is a layout handle for one of our children
                    const $el = $(handle.pyChild.anvil$hooks.domElement);
                    const originalWidthProp = parseFloat(handle.pyChild._anvil?.componentSpec?.layout_properties?.width || $el.outerWidth())
                    return {
                        mouseX,
                        originalHandleX: handle.x,
                        originalWidth: $el.width(),
                        originalWidthProp,
                    };
                } else {
                    // This is our own height/width handle.
                    return {
                        mouseX: mouseX,
                        mouseY: mouseY,
                        originalHandleY: handle.y,
                        originalHandleX: handle.x,
                        originalHeight: self._anvil.element.height(),
                        originalHeightProp: parseFloat(self._anvil.getPropJS("height") || self._anvil.element.find(`.${getCssPrefix()}holder.xypanel-${self._anvil.panelId}`).outerHeight()),
                        originalWidthProp: parseFloat(self._anvil.getPropJS("width") || self._anvil.element.find(`.${getCssPrefix()}holder.xypanel-${self._anvil.panelId}`).outerWidth())
                    };
                }
            };

            let getWidthSnap = (handle, grab, totalDx) => {
                let snapX = undefined;
                for (let c of self._anvil.components) {
                    if (c.component === handle.pyChild) { continue; }
                    let elt = $(c.component.anvil$hooks.domElement);
                    let w = elt.outerWidth(), h = elt.outerHeight();
                    let offset = elt.offset();
                    snapX = trySnap(snapX, grab.originalHandleX+totalDx, offset.left+w, -w, -SNAP_SPACING, offset.top+h/2);;
                }
                if (snapX !== undefined) {
                    var myOffset = self._anvil.element.offset();
                    var myHeight = self._anvil.element.height();
                    var guidelines = [{x1: snapX.pos, y1: myOffset.top, x2: snapX.pos, y2: myOffset.top+myHeight, lineWidth: 2}];
                    if (snapX.standoff) {
                        guidelines.push = [{x1: snapX.pos+SNAP_SPACING, y1: snapX.standoff, x2: snapX.pos, y2: snapX.standoff, lineWidth: 2}];
                    }
                    return [snapX.pos - grab.originalHandleX, guidelines];
                } else {
                    return [totalDx, []];
                }
            }

            self._anvil.handleDrag = function(handle, grab, mouseX, mouseY) {
                if (handle.pyChild) {
                    // This is a layout handle for one of our children
                    let [totalDx, guidelines] = getWidthSnap(handle, grab, mouseX - grab.mouseX);
                    handle.x = grab.originalHandleX + totalDx;
                    const $el = $(handle.pyChild.anvil$hooks.domElement);
                    $el.width(grab.originalWidth + totalDx);
                } else if(handle.prop=='height') {
                    // This is our own height handle
                    var totalDy = mouseY - grab.mouseY;
                    handle.y = grab.originalHandleY + totalDy;
                    self._anvil.element.find(`.${getCssPrefix()}holder.xypanel-${self._anvil.panelId}`).height(grab.originalHeight + totalDy);
                    if (PyDefUtils.updateHeight)
                        PyDefUtils.updateHeight();
                } else if (handle.prop=='width') {
                    // This is our own width handle
                    var totalDx = mouseX - grab.mouseX;
                    handle.x = grab.originalHandleX + totalDx;
                    self._anvil.element.find(`.${getCssPrefix()}holder.xypanel-${self._anvil.panelId}`).css("width", grab.originalWidthProp + totalDx*handle.factor);
                    self._anvil.updateHatching(grab.originalWidthProp + totalDx*handle.factor);
                }

                return handle;
            };

            self._anvil.handleDrop = function(handle, grab, mouseX, mouseY) {
                if (handle.pyChild) {
                    // This is a layout handle for one of our children
                    var r = { layoutProperties: {}};
                    let [totalDx, guidelines] = getWidthSnap(handle, grab, mouseX - grab.mouseX);

                    r.layoutProperties[handle.pyChild._anvil?.componentSpec?.name] = {
                        width: grab.originalWidthProp + totalDx,
                    };

                    return r;
                } else {
                    // This is our own height handle
                    var r = { properties: {}};
                    var totalDy = mouseY - grab.mouseY;
                    var totalDx = mouseX - grab.mouseX;

                    var selfName = self._anvil?.componentSpec?.name;
                    if (handle.prop == 'height') {

                        r.properties[selfName] = {
                            height: Math.max(0, grab.originalHeightProp + totalDy),
                        };
                    } else {
                        r.properties[selfName] = {
                            width: Math.max(0, grab.originalWidthProp + totalDx*handle.factor),
                        };
                        self._anvil.updateHatching(grab.originalWidthProp + totalDx*handle.factor);
                    };

                    return r;
                }
            };

            self._anvil.handleDoubleClick = function(handle) {
                if (handle.prop === "width") {
                    var selfName = self._anvil.element.hasClass("anvil-designer-component-namespace") ? "" : self._anvil?.componentSpec.name;
                    let r = { properties: {} };
                    r.properties[selfName] = {
                        width: null,
                    };
                    return r;
                }
            };

        }));
    }, 'DesignXYPanel', [pyModule["XYPanel"]]);
};
